import script from "./QModalGravity.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalGravity.vue?vue&type=script&setup=true&lang=js"

import "./QModalGravity.vue?vue&type=style&index=0&id=2de6c998&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de6c998"]])

export default __exports__